import { render, staticRenderFns } from "./DashboardHr.vue?vue&type=template&id=6938183c&scoped=true&"
import script from "./DashboardHr.vue?vue&type=script&lang=js&"
export * from "./DashboardHr.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHr.vue?vue&type=style&index=0&id=6938183c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6938183c",
  null
  
)

export default component.exports